/* eslint-disable no-useless-escape */
export const regexp = {
  name: '^[А-ЯЁЙ][а-яёй]*([-—–− ][А-ЯЁЙ][а-яёй]*)*$',
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  address: '^(\\d{6},\\s{0,1}(.+),\\s{0,1}(.+))$'
}
